module.exports = __webpack_public_path__ + "img/1.0969970f.jpg";